import { Reveal } from "@/components/Reveal";
import { Flag, Users, Radio } from "lucide-react";

const steps = [
  {
    n: "01",
    icon: Flag,
    title: "Create your convoy",
    body: "One rider starts a convoy and drops the route — meetup point, fuel stops, regroup spots. Takes under a minute, works for cars and bikes alike.",
    img: "https://images.unsplash.com/photo-1511679760730-6ef1a072274b?q=80&w=1200&auto=format&fit=crop",
    alt: "Friends gathered at a car watching the sunset before a ride",
  },
  {
    n: "02",
    icon: Users,
    title: "Bring the crew in",
    body: "Share one invite and everyone joins — drivers, riders, passengers. No accounts to fumble with at the petrol station while engines are running.",
    img: "https://images.unsplash.com/photo-1589635076932-d3e65ddbb7f6?q=80&w=1200&auto=format&fit=crop",
    alt: "Motorcycle rider under a starry night sky",
  },
  {
    n: "03",
    icon: Radio,
    title: "Ride connected",
    body: "Every rider appears live on one shared map. Someone drops back at a toll or a light? The convoy sees it instantly and regroups. No one left behind.",
    img: "https://images.unsplash.com/photo-1550242499-b5171f56de56?q=80&w=1200&auto=format&fit=crop",
    alt: "Car moving through city streets with motion blur",
  },
];

export const HowItWorks = () => (
  <section id="how-it-works" className="relative mx-auto max-w-6xl px-6 py-24 sm:py-32" data-testid="how-it-works-section">
    <Reveal>
      <p className="label-tech text-[#FF3333]">How it works</p>
      <h2 className="mt-4 max-w-2xl font-display text-4xl font-black tracking-tighter text-white sm:text-5xl lg:text-6xl">
        Three steps. Zero lost riders.
      </h2>
    </Reveal>

    <div className="mt-16 space-y-20 sm:mt-24 sm:space-y-28">
      {steps.map((s, i) => (
        <Reveal key={s.n} delay={0.05}>
          <div
            className={`grid items-center gap-8 md:grid-cols-12 md:gap-12 ${
              i % 2 === 1 ? "" : ""
            }`}
            data-testid={`how-it-works-step-${s.n}`}
          >
            <div className={`relative md:col-span-7 ${i % 2 === 1 ? "md:order-2" : ""}`}>
              <div className="group relative overflow-hidden rounded-3xl border border-white/10">
                <img
                  src={s.img}
                  alt={s.alt}
                  loading="lazy"
                  className="aspect-[16/10] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
                <span className="text-outline-red pointer-events-none absolute -bottom-4 left-4 font-display text-[6rem] font-black leading-none sm:text-[8rem]">
                  {s.n}
                </span>
              </div>
            </div>
            <div className={`md:col-span-5 ${i % 2 === 1 ? "md:order-1" : ""}`}>
              <div className="flex items-center gap-4">
                <span className="flex h-12 w-12 items-center justify-center rounded-2xl border border-white/10 bg-white/5">
                  <s.icon className="h-5 w-5 text-[#00F0FF]" />
                </span>
                <span className="label-tech text-neutral-500">Chapter {s.n}</span>
              </div>
              <h3 className="mt-6 font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
                {s.title}
              </h3>
              <p className="mt-4 max-w-md text-base leading-relaxed text-neutral-400">{s.body}</p>
            </div>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
